module.exports = __webpack_public_path__ + "static/media/green.68565e2c.png";